// extracted by mini-css-extract-plugin
module.exports = {"root":"ShippingAddress_root__2PsvZ","shippingAddressList":"ShippingAddress_shippingAddressList__1uLyt","locationIconContainer":"ShippingAddress_locationIconContainer__IQgD8"};